var _a;
import { humanizePercentValue } from "./percent";
import { humanizeTimeValue, timeFormatUnitIds } from "./time";
import { humanizeDataValue, dataFormatUnitIds } from "./data";
import { humanizeDataRateValue, dataRateFormatUnitIds } from "./dataRate";
import { humanizeNumberValue } from "./number";
import { percentFormatUnitIds, } from "../constants";
import { isBoolean } from "lodash";
export var FormatType;
(function (FormatType) {
    FormatType["None"] = "none";
    FormatType["Short"] = "short";
    FormatType["Percent"] = "percent";
    FormatType["Time"] = "time";
    FormatType["Data"] = "data";
    FormatType["DataRate"] = "data_rate";
})(FormatType || (FormatType = {}));
export var formatUnitIds = (_a = {},
    _a[FormatType.None] = [],
    _a[FormatType.Short] = [],
    _a[FormatType.Percent] = percentFormatUnitIds,
    _a[FormatType.Time] = timeFormatUnitIds,
    _a[FormatType.Data] = dataFormatUnitIds,
    _a[FormatType.DataRate] = dataRateFormatUnitIds,
    _a);
/**
 * @param value
 * @param precision
 * @param fixedPrecision 默认为 `true`，设置为 `false` 时，`1.50` 会变成 `1.5`。
 * @returns
 */
export var convertValueByPrecision = function (value, precision, fixedPrecision) {
    if (precision === undefined) {
        return value.toString();
    }
    var converted = value.toFixed(precision);
    if (fixedPrecision === false) {
        return (+converted).toString();
    }
    return converted;
};
export var formatValue = function (value, format) {
    if (format) {
        var type_1 = format.type;
        if (!type_1) {
            if (format.unit) {
                type_1 = FormatType.Short;
                Object.entries(formatUnitIds).map(function (_a) {
                    var formatType = _a[0], units = _a[1];
                    if (units
                        .map(function (unit) { return unit.toLocaleLowerCase(); })
                        .includes(format.unit.toLocaleLowerCase())) {
                        type_1 = formatType;
                    }
                });
            }
            else {
                type_1 = FormatType.None;
            }
        }
        var precision = (format === null || format === void 0 ? void 0 : format.precision) === undefined ? 2 : format.precision;
        var fixedPrecision = isBoolean(format === null || format === void 0 ? void 0 : format.fixedPrecision)
            ? format === null || format === void 0 ? void 0 : format.fixedPrecision : true;
        switch (type_1) {
            case FormatType.Percent: {
                var percentValue = humanizePercentValue(value, format.unit);
                return [
                    convertValueByPrecision(percentValue, precision, fixedPrecision) + "%",
                    null,
                ];
            }
            case FormatType.Time: {
                var _a = humanizeTimeValue(value, format.unit, format.targetUnit), timeValue = _a[0], timeUnitDisplay = _a[1];
                return [
                    "" + convertValueByPrecision(timeValue, (format === null || format === void 0 ? void 0 : format.precision) === undefined ? 1 : format.precision, fixedPrecision),
                    timeUnitDisplay,
                ];
            }
            case FormatType.Data: {
                var _b = humanizeDataValue(value, format.unit, format.targetUnit), dataValue = _b[0], dataUnitDisplay = _b[1];
                return [
                    "" + convertValueByPrecision(dataValue, precision, fixedPrecision),
                    dataUnitDisplay,
                ];
            }
            case FormatType.DataRate: {
                var _c = humanizeDataRateValue(value, format.unit, format.targetUnit), dataRateValue = _c[0], dataRateUnitDisplay = _c[1];
                return [
                    "" + convertValueByPrecision(dataRateValue, precision, fixedPrecision),
                    dataRateUnitDisplay,
                ];
            }
            case FormatType.None: {
                return [convertValueByPrecision(value, precision, fixedPrecision), ""];
            }
            default: {
                return [
                    humanizeNumberValue(value, format.unit, precision, fixedPrecision),
                    format.unit,
                ];
            }
        }
    }
    else {
        return [humanizeNumberValue(value), null];
    }
};
//# sourceMappingURL=valueFormatter.js.map